import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import { sortBy } from "lodash";

const styles = () => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  input: {
    width: "auto",
    maxWidth: "366px",
    fontSize: "14px",
    padding: "0 10px",
    height: "56px",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.09)",
    borderRadius: "4px"
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 306
    }
  }
};

const MultipleSelect = props => {
  const { classes, handleChange, variants, selectedVariants, disabled } = props;

  return (
    <div className={classes.root}>
      <FormControl
      disabled={disabled}
      fullWidth>
        <Select
          multiple
          value={selectedVariants}
          onChange={handleChange}
          input={<Input className={classes.input} id="select-multiple-checkbox" />}
          renderValue={selected => selected.sort().join(", ")}
          MenuProps={MenuProps}
        >
          {variants.length === 0 && <MenuItem disabled>No rent charges have been found</MenuItem>}
          {variants.length > 0 && sortBy(variants, ["chargeType", "chargeCode"]).map(variant => (
            <MenuItem key={variant.chargeCode} value={variant.chargeCode} style={{ backgroundColor: "white" }}>
              <Checkbox checked={selectedVariants.indexOf(variant.chargeCode) > -1} style={selectedVariants.indexOf(variant.chargeCode) > -1 ? { color: "#005aa9" } : {}} />
              <ListItemText primary={`${variant.chargeType}-${variant.chargeCode}`} style={{ textTransform: "none" }} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(MultipleSelect);
